export function formatPhoneBR(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  const part1 = digits.slice(0, 2)
  const part2 = digits.length > 10 ? digits.slice(2, 7) : digits.slice(2, 6)
  const part3 = digits.length > 10 ? digits.slice(7, 11) : digits.slice(6, 10)
  let out = ''
  if (part1) out = `(${part1}`
  if (part1 && part1.length === 2) out += ') '
  if (part2) out += part2
  if (part3) out += `-${part3}`
  return out
}

